export default __webpack_public_path__ + "static/mockup-effort-high-low-67d9653829d1fb9e6e2355af70a87481.webp";